import Badge from '@mui/material/Badge';
import { StyleObj } from '../../@types';
import { Stack, StackProps, Typography } from '@mui/material';
import useLocalization from '../../hooks/useLocalization';

import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  badge: {
    '& .MuiBadge-badge': { fontSize: 14, height: 24, minWidth: 24, borderRadius: '50%', p: 0 },
  },
};

type BetslipBetCountProps = StackProps & {
  numberOfBets: number;
};

const BetslipBetCount = ({ numberOfBets, ...rest }: BetslipBetCountProps) => {
  const { t } = useLocalization();

  return (
    <Stack
      direction='row'
      spacing={2.5}
      {...rest}
      sx={mergeSx(
        {
          alignItems: 'center',
          p: 1,
        },
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])
      )}
    >
      <Badge badgeContent={numberOfBets} color='primary' sx={styles.badge} />
      <Typography
        variant='subtitle2'
        sx={{
          fontWeight: 600,
          color: 'neutral.600',
        }}
      >
        {t('betslip')}
      </Typography>
    </Stack>
  );
};

export default BetslipBetCount;
